module.exports = __webpack_public_path__ + "img/no-schedule-alert-v2.07ef3783.svg";